const LazyVideo = () => {
  const lazyVideos = [...document.querySelectorAll(".lazy-video")];
  
  if (lazyVideos.length > 0) {
    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.src = entry.target.dataset.src;
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '20px',
    });
    
    lazyVideos.forEach(function (video) {
      observer.observe(video);
    });
  }
};

export default LazyVideo;
